import { useMemo } from "react";
import ClaimShift from "../../components/drawers/ClaimShift";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useClaimShiftDrawer = ({ queryOptions }: any) => {
    const { visible, open, close, selected } = useVisible();

    const drawer = useMemo(() => {
        return (
            <ClaimShift
                visible={visible}
                close={close}
                values={selected}
                queryOptions={queryOptions}
            />
        );
    }, [visible, close, selected, queryOptions]);

    return { open, drawer };
}
